const MENU_PERMISSIONS = {
  // Config screens (keep :read/:write split)
  ADMIN: 'egov:config.empresas:write',
  EMPREGADORES: 'egov:config.empresas:read',
  // Consultation screens (single permission = full access)
  ANALISTA_AGNES: 'egov:folha.rubricas',
  SAUDE_SEGURANCA_AGENTES_NOCIVOS_APOSENTADORIA_ESPECIAL: 'egov:saude.agentes-nocivos',
  AFASTADOS_E_INATIVOS: 'egov:trabalhador.afastamento',
  CBO: 'egov:trabalhador.cbo',
  HORARIOS_E_JORNADA: 'egov:trabalhador.horarios',
  FOLHA_DE_PAGAMENTO: 'egov:folha.rubricas',
  DCTF: 'egov:encargos.dctf',
  MENSAGENS_ECAC: 'egov:encargos.mensagens-ecac',
  EGOV: 'egov:egov.cessao',
  CESSAO: 'egov:egov.cessao',
  CERTIDAO_FEDERAL: 'egov:certidoes.cnd',
  CRF: 'egov:certidoes.crf',
  CNDT: 'egov:certidoes.cndt',
  CENTRAL_REPROCESSAMENTO: 'egov:reprocessamento',
  // Config — granular (CON-4960)
  CONFIG_USUARIOS_READ: 'egov:config.usuarios:read',
  CONFIG_USUARIOS_WRITE: 'egov:config.usuarios:write',
  CONFIG_USUARIOS_PERMISSOES_WRITE: 'egov:config.usuarios-permissoes:write',
  CONFIG_USUARIOS_SEGURANCA_WRITE: 'egov:config.usuarios-seguranca:write',
  CONFIG_USUARIOS_ESTAB_READ: 'egov:config.usuarios-estabelecimentos:read',
  CONFIG_EMPRESAS_READ: 'egov:config.empresas:read',
  CONFIG_EMPRESAS_WRITE: 'egov:config.empresas:write',
  CONFIG_ESOCIAL_IMPORTACAO_READ: 'egov:config.esocial-importacao:read',
  CONFIG_ESOCIAL_IMPORTACAO_WRITE: 'egov:config.esocial-importacao:write',
  CONFIG_ECAC_INTEGRACAO_READ: 'egov:config.ecac-integracao:read',
  CONFIG_ECAC_MENSAGENS_WRITE: 'egov:config.ecac-mensagens:write',
  CONFIG_AUDITORIA_READ: 'egov:config.auditoria:read',
  CONFIG_DOCUMENTOS_READ: 'egov:config.documentos:read',
  CONFIG_TABELAS_READ: 'egov:config.tabelas:read',
  CONFIG_TABELAS_WRITE: 'egov:config.tabelas:write',
  CONFIG_PARAMETROS_ANALISE_READ: 'egov:config.parametros-analise:read',
  CONFIG_PARAMETROS_ANALISE_WRITE: 'egov:config.parametros-analise:write',
  CONFIG_PERFIS_READ: 'egov:config.perfis:read',
  CONFIG_PERFIS_WRITE: 'egov:config.perfis:write',
  REPROCESSAMENTO: 'egov:reprocessamento',
  EXPORTACOES: 'egov:arquivos.exportacoes',
  CBO_EDITAR: 'egov:trabalhador.cbo:write',
  HORARIOS_E_JORNADA_EDITAR: 'egov:trabalhador.horarios:write',
  FOLHA_DE_PAGAMENTO_EDITAR: 'egov:folha.rubricas:write',
  DCTF_EDITAR: 'egov:encargos.dctf:write',
  MENSAGENS_ECAC_EDITAR: 'egov:encargos.mensagens-ecac:write',
  CERTIDAO_FEDERAL_EDITAR: 'egov:certidoes.cnd:write',
  CRF_EDITAR: 'egov:certidoes.crf:write',
  CNDT_EDITAR: 'egov:certidoes.cndt:write',
  CENTRAL_REPROCESSAMENTO_EDITAR: 'egov:reprocessamento:write',
};

export default MENU_PERMISSIONS;
